import * as yup from 'yup';

import { ContentTypeEnum } from 'constants-content';
import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: [
          ContentTypeEnum.Content,
          ContentTypeEnum.Notice,
          ContentTypeEnum.ScheduledContent,
          ContentTypeEnum.ScheduledNotice,
          ContentTypeEnum.Promotion,
          ContentTypeEnum.Static,
          ContentTypeEnum.Perk,
        ],
      },
    ],
  },
};

export class ContentType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Content';

  friendlyName = 'Content';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;
  properties = properties;

  get example() {
    return {
      _id: '000000Be3RPQB9nF9WZlwQ',
      type: ContentTypeEnum.Content,
    };
  }

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const definition = new ContentType();

Types.addBaseType(definition);
export { definition as ContentDefinition };
